import ScrollReveal from 'scrollreveal'

const sr = ScrollReveal();
const enableMobile = false;
const shortTrans = 250;
const longTrans = 500;

sr.reveal('.reveal', {
    delay: shortTrans,
    scale: 0.95,
    distance: '2rem',
    origin: 'bottom',
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-zoom-in', {
    delay: shortTrans,
    scale: 1.05,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq', {
    delay: shortTrans,
    scale: 0.95,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    interval: 50,
    reset: false,
})

sr.reveal('.reveal-seq-r', {
    delay: shortTrans, distance: '10%', origin: 'right',

    duration: longTrans, mobile: enableMobile, cleanup: true, reset: false,
})

sr.reveal('.reveal-seq-l', {
    delay: shortTrans,
    distance: '10%',
    origin: 'left',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq-t', {
    delay: shortTrans,
    distance: '10%',
    origin: 'top',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
})

sr.reveal('.reveal-seq-b', {
    delay: shortTrans,
    distance: '2rem',
    origin: 'bottom',
    interval: 50,
    duration: longTrans,
    mobile: enableMobile,
    cleanup: true,
    reset: false,
});

window.addEventListener("load", () => {
    sr.delegate({ type: "resize" });

});